function getPrinterSelectDescription(option) {
  return option.email
}

function getPrinterSelectItemLabel(option) {
  return option.name
}

export function getPrinterSelectLabel(option) {
  return `${option.name} (${option.email})`
}

export function getPrinterSelectValue(option) {
  return option.id
}

export function getListItemProps(option) {
  return {
    description: getPrinterSelectDescription(option),
    text: getPrinterSelectItemLabel(option),
  }
}
